import { render, staticRenderFns } from "./DragToRankInputFr.vue?vue&type=template&id=0d51ee88&scoped=true&"
import script from "./DragToRankInputFr.vue?vue&type=script&lang=ts&"
export * from "./DragToRankInputFr.vue?vue&type=script&lang=ts&"
import style0 from "./DragToRankInputFr.vue?vue&type=style&index=0&id=0d51ee88&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d51ee88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
